{
  "AGENT_BOTS": {
    "HEADER": "Боты",
    "LOADING_EDITOR": "Загрузка редактора...",
    "DESCRIPTION": "Боты — это ваши незаменимые помощники. Они берут на себя рутину, чтобы вы могли сосредоточиться на важном. Попробуйте! Управлять ботами можно на этой странице, а новых — создавать с помощью кнопки «Добавить бота».",
    "LEARN_MORE": "Подробнее о ботах-агентах",
    "COUNT": "{n} бот | {n} боты",
    "SEARCH_PLACEHOLDER": "Поиск ботов...",
    "NO_RESULTS": "Не найдено ботов, соответствующих вашему запросу",
    "GLOBAL_BOT": "Системный бот",
    "GLOBAL_BOT_BADGE": "Система",
    "AVATAR": {
      "SUCCESS_DELETE": "Аватар бота был успешно удалён",
      "ERROR_DELETE": "Ошибка при удалении аватара бота, попробуйте ещё раз"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Выберите бота агента",
      "DESC": "Назначьте бота агента для источника. Он может обрабатывать первоначальные диалоги и передавать их живому агенту при необходимости.",
      "SUBMIT": "Обновить",
      "DISCONNECT": "Отключить бота",
      "SUCCESS_MESSAGE": "Бот агента успешно обновлён.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Бот агента успешно отключён.",
      "ERROR_MESSAGE": "Не удалось обновить бота агента. Пожалуйста, повторите попытку позже.",
      "DISCONNECTED_ERROR_MESSAGE": "Не удалось отключить бота агента. Пожалуйста, повторите попытку позже.",
      "SELECT_PLACEHOLDER": "Выбрать бота"
    },
    "ADD": {
      "TITLE": "Добавить бота",
      "CANCEL_BUTTON_TEXT": "Отменить",
      "API": {
        "SUCCESS_MESSAGE": "Бот успешно добавлен.",
        "ERROR_MESSAGE": "Не удалось добавить бота. Пожалуйста, повторите попытку позже."
      }
    },
    "LIST": {
      "404": "Боты не найдены. Вы можете создать бота, нажав кнопку 'Добавить бота' ↗",
      "LOADING": "Получение ботов...",
      "TABLE_HEADER": {
        "DETAILS": "Детали бота",
        "URL": "URL вебхука",
        "ACTIONS": "Действия"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Удалить",
      "TITLE": "Удалить бота",
      "CONFIRM": {
        "TITLE": "Подтвердите удаление",
        "MESSAGE": "Вы уверены, что хотите удалить {name}?",
        "YES": "Да, удалить",
        "NO": "Нет, не удалять"
      },
      "API": {
        "SUCCESS_MESSAGE": "Бот успешно удален.",
        "ERROR_MESSAGE": "Не удалось удалить бота. Пожалуйста, повторите попытку позже."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Редактировать",
      "TITLE": "Редактировать бота",
      "API": {
        "SUCCESS_MESSAGE": "Бот успешно обновлен.",
        "ERROR_MESSAGE": "Не удалось обновить бота. Пожалуйста, повторите попытку позже."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "Токен доступа",
      "DESCRIPTION": "Скопируйте токен доступа и безопасно сохраните его",
      "COPY_SUCCESSFUL": "Токен доступа скопирован в буфер обмена",
      "RESET_SUCCESS": "Токен доступа успешно сгенерирован",
      "RESET_ERROR": "Не удалось сгенерировать токен доступа. Попробуйте ещё раз"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Аватар бота"
      },
      "NAME": {
        "LABEL": "Имя бота",
        "PLACEHOLDER": "Введите имя бота",
        "REQUIRED": "Имя бота обязательно"
      },
      "DESCRIPTION": {
        "LABEL": "Описание",
        "PLACEHOLDER": "Что делает этот бот?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL вебхука",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "Webhook URL обязателен"
      },
      "ERRORS": {
        "NAME": "Имя бота обязательно",
        "URL": "Webhook URL обязателен",
        "VALID_URL": "Пожалуйста, введите действительный URL, начинающийся с http:// или https://"
      },
      "CANCEL": "Отменить",
      "CREATE": "Создать бота",
      "UPDATE": "Обновить бота"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Настройте webhook бота для интеграции с вашими пользовательскими сервисами. Бот будет получать и обрабатывать события из разговоров и может отвечать на них."
    },
    "TYPES": {
      "WEBHOOK": "Webhook бот"
    }
  }
}
